// src/composables/useAuth.js
import { ref } from "vue";
import { adminApi } from "@/services/api";
import { useRouter } from "vue-router";
import { useToast } from "./useToast";

const currentUser = ref(JSON.parse(localStorage.getItem("admin_user")) || null);
const isAuthenticated = ref(!!localStorage.getItem("admin_token"));
// const currentUser = ref(null);
// const isAuthenticated = ref(false);
const loading = ref(false);

export function useAuth() {
  const router = useRouter();
  const toast = useToast();

  const login = async (credentials) => {
    loading.value = true;
    try {
      const response = await adminApi.login(credentials);
      const { user, token } = response.data.data;

      // Save to localStorage
      localStorage.setItem("admin_token", token);
      localStorage.setItem("admin_user", JSON.stringify(user));

      // Update state
      currentUser.value = user;
      isAuthenticated.value = true;

      toast.success("Đăng nhập thành công");
      return true;
    } catch (error) {
      toast.error(error.response?.data?.message || "Đăng nhập thất bại");
      return false;
    } finally {
      loading.value = false;
    }
  };

  const loginWithOTP = async (credentials) => {
    loading.value = true;
    try {
      const response = await adminApi.loginWithOTP(credentials);
      const { user, token } = response.data.data;

      // Save to localStorage
      localStorage.setItem("admin_token", token);
      localStorage.setItem("admin_user", JSON.stringify(user));

      // Update state
      currentUser.value = user;
      isAuthenticated.value = true;

      toast.success("Đăng nhập thành công");

      return true;
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      loading.value = false;
    }
  };

  const logout = async () => {
    try {
      await adminApi.logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear localStorage
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");

      // Reset state
      currentUser.value = null;
      isAuthenticated.value = false;

      // Redirect to login
      router.push("/login-admin.html");
      toast.success("Đã đăng xuất");
    }
  };

  const fetchCurrentUser = async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      isAuthenticated.value = false;
      return;
    }

    try {
      const response = await adminApi.getMe();
      currentUser.value = response.data.data;
      isAuthenticated.value = true;

      // Update localStorage
      localStorage.setItem("admin_user", JSON.stringify(currentUser.value));
    } catch (error) {
      console.error("Fetch user error:", error);
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      isAuthenticated.value = false;
    }
  };

  const initAuth = () => {
    const token = localStorage.getItem("admin_token");
    const userStr = localStorage.getItem("admin_user");

    if (token && userStr) {
      try {
        currentUser.value = JSON.parse(userStr);
        isAuthenticated.value = true;
      } catch (error) {
        console.error("Parse user error:", error);
      }
    }
  };

  const hasRole = (role) => {
    if (!currentUser.value) return false;
    if (Array.isArray(role)) {
      return role.includes(currentUser.value.role);
    }
    return currentUser.value.role === role;
  };

  const hasPermission = (permission) => {
    if (!currentUser.value) return false;

    // Super admin has all permissions
    if (currentUser.value.role === "super_admin") return true;

    if (!currentUser.value.permissions) return false;

    return currentUser.value.permissions.some((p) => p.name === permission);
  };

  const hasAnyPermission = (permissions) => {
    if (!currentUser.value) return false;
    if (currentUser.value.role === "super_admin") return true;
    if (!currentUser.value.permissions) return false;

    return permissions.some((permission) =>
      currentUser.value.permissions.some((p) => p.name === permission),
    );
  };

  const updateCurrentUser = (user) => {
    currentUser.value = user;
    localStorage.setItem("admin_user", JSON.stringify(user));
  };

  const sendOTP = (payload) => adminApi.sendOtp(payload);

  return {
    currentUser,
    isAuthenticated,
    loading,
    login,
    logout,
    fetchCurrentUser,
    initAuth,
    hasRole,
    hasPermission,
    hasAnyPermission,
    updateCurrentUser,
    sendOTP,
    loginWithOTP,
  };
}
